import { Link } from 'react-router';

import { env } from '@/lib/env';

/** Aviso de la beta por invitación (plan §17.1, paso 3). */
export function AvisoBeta() {
  if (!env.beta) return null;
  return (
    <div
      role="note"
      className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 bg-amarillo-400/15 px-4 py-2 text-center text-sm text-texto"
    >
      <span className="text-texto-2">
        Estamos mejorando tu experiencia en la plataforma. Si notas algo que debamos corregir,{' '}
        <Link to="/opinion" className="font-semibold">
          avísanos
        </Link>
      </span>
    </div>
  );
}
